import React from "react";
import { Sparkles, PencilLine } from "lucide-react";

// Near-copy of orgadmin/mcq/ModeSelectionScreen.jsx — same card/layout, Behavioural copy.
const ModeCard = ({ icon: Icon, title, description, onClick }) => (
  <div
    onClick={onClick}
    className="gradient-ring group relative flex flex-col gap-5 p-8 rounded-2xl dark:glass-effect bg-bgSecondary border border-white/10 shadow-lg hover:shadow-xl hover:shadow-blue-500/5 transition-all duration-300 cursor-pointer flex-1"
  >
    <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-pink-500/20 to-blue-500/20 group-hover:from-pink-500/30 group-hover:to-blue-500/30 transition-all duration-300">
      <Icon size={22} className="text-blue-400" />
    </div>

    <div className="space-y-2">
      <h3 className="text-lg font-semibold dark:text-white text-textPrimary">
        {title}
      </h3>
      <p className="text-sm dark:text-gray-400 text-textSecondary leading-relaxed">
        {description}
      </p>
    </div>

    <button className="button self-start mt-2">
      <span>Get Started →</span>
    </button>
  </div>
);

const ModeSelectionScreen = ({ onSelectMode }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 py-12">
      <div className="text-center mb-10 space-y-2">
        <h2 className="text-2xl font-bold dark:text-white text-textPrimary">
          How would you like to build this behavioural set?
        </h2>
        <p className="text-sm dark:text-gray-400 text-textSecondary">
          Choose a method to get started
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-6 w-full max-w-2xl">
        <ModeCard
          icon={Sparkles}
          title="Generate with AI"
          description="Describe the role (or pick an existing JD) and a time budget. AI recommends which competencies to assess and drafts scenario questions with ranked options for you to edit."
          onClick={() => onSelectMode("ai")}
        />
        <ModeCard
          icon={PencilLine}
          title="Start from Defaults"
          description="Start from 15 platform-default questions across all 5 competencies, or build entirely from scratch."
          onClick={() => onSelectMode("manual")}
        />
      </div>
    </div>
  );
};

export default ModeSelectionScreen;
